import { Address, DirectTaskBankConnectorResponse } from '@frame/components/screens/tasks/screens/strategies/bank/types'
import { DirectAPIError } from '@frame/lib/api/common/types'
import {
  ArgyleAccountResponse,
  CreateDirectTaskBody,
  GetAllDirectTasksResponse,
  UpdateTaxInfoRequest,
  UploadAndClassifyFileResponse,
  UploadFileError,
  UploadFileResponse,
} from '@frame/lib/api/tasks/types'
import { FetchClient } from '@frame/lib/api/types'

import { AttachFilesBody, CompleteDirectTaskBody, DirectTasksResponse, UpdateDirectTaskBody } from './types'

const BASE_PREFIX = `/api/truework-js/client/tasks`

export const directTaskEndpoints = (fetchClient: FetchClient) => {
  return {
    async createDirectTask(createDirectTaskBody: CreateDirectTaskBody) {
      return fetchClient<DirectTasksResponse>(BASE_PREFIX, {
        method: 'POST',
        body: JSON.stringify(createDirectTaskBody),
      })
    },
    async updateDirectTask(directTaskId: string, updateDirectTaskBody: UpdateDirectTaskBody) {
      return fetchClient<DirectTasksResponse>(`${BASE_PREFIX}/${directTaskId}`, {
        method: 'PUT',
        body: JSON.stringify(updateDirectTaskBody),
      })
    },
    async completeDirectTask(directTaskId: string, completeDirectTaskBody: CompleteDirectTaskBody) {
      return fetchClient<DirectTasksResponse>(`${BASE_PREFIX}/${directTaskId}/complete`, {
        method: 'POST',
        body: JSON.stringify(completeDirectTaskBody),
      })
    },
    async verifyTask(directTaskId: string) {
      return fetchClient<DirectTasksResponse>(`${BASE_PREFIX}/${directTaskId}/verify`, {
        method: 'POST',
      })
    },
    async skipDirectTask(directTaskId: string) {
      return fetchClient<DirectTasksResponse>(`${BASE_PREFIX}/${directTaskId}/skip`, { method: 'POST' })
    },
    async unSkipDirectTask(directTaskId: string) {
      return fetchClient<DirectTasksResponse>(`${BASE_PREFIX}/${directTaskId}/un_skip`, { method: 'POST' })
    },
    async getAllDirectTasks() {
      return fetchClient<GetAllDirectTasksResponse>(`${BASE_PREFIX}`, { method: 'GET' })
    },
    async uploadFile(fileUpload: FormData) {
      return fetchClient<UploadFileResponse, UploadFileError>('/api/files', {
        method: 'POST',
        body: fileUpload,
      })
    },
    async attachFiles(taskId: string, attachFilesBody: AttachFilesBody) {
      return fetchClient<DirectTasksResponse>(`${BASE_PREFIX}/${taskId}/attach_files`, {
        method: 'POST',
        body: JSON.stringify(attachFilesBody),
      })
    },
    async getConnectorAccount(accountId: string, directTaskId: string) {
      const url = `${BASE_PREFIX}/${directTaskId}/connector_account/`
      return fetchClient<ArgyleAccountResponse>(url, {
        method: 'POST',
        body: JSON.stringify({ account_id: accountId }),
      })
    },
    async createBankStatedInfo(phone_number: string, address: Address, directTaskId: string) {
      const url = `${BASE_PREFIX}/${directTaskId}/configure-bank/`
      return fetchClient<DirectTaskBankConnectorResponse>(url, {
        method: 'POST',
        body: JSON.stringify({ phone_number, address }),
      })
    },
    async persistTaxInfo(directTaskId: string, request: UpdateTaxInfoRequest) {
      return fetchClient<DirectTasksResponse, DirectAPIError>(`${BASE_PREFIX}/${directTaskId}/tax`, {
        method: 'POST',
        body: JSON.stringify(request),
      })
    },
    async matchIncome(directTaskId: string, incomeStreamId: string, transactionId: string) {
      return fetchClient<{ detail: string }>(`${BASE_PREFIX}/${directTaskId}/match-income`, {
        method: 'POST',
        body: JSON.stringify({ income_stream_id: incomeStreamId, transaction_id: transactionId }),
      })
    },
    async uploadAndClassifyFile(directTaskId: string, formData: FormData) {
      return fetchClient<UploadAndClassifyFileResponse, DirectAPIError>(
        `${BASE_PREFIX}/${directTaskId}/upload_and_classify_file`,
        {
          method: 'POST',
          body: formData,
        }
      )
    },
    async removeFile(directTaskId: string, fileIds: string[]) {
      return fetchClient(`${BASE_PREFIX}/${directTaskId}/remove_file`, {
        method: 'POST',
        body: JSON.stringify({ file_ids: fileIds }),
      })
    },
  }
}
